<template>
    <div class="mb-4 border-top mt-3 pt-3" >
        <label
            for="workerJob-select"
            class="form-label fs-15 text-success fs-16 text-uppercase fw-semibold mb-3"
            >{{ $t('Position') }}</label
        >
        <br />
        <div class="row g-2 list_filtr" >
            <div class="col-lg-6">
                <div class="form-check mb-2" >
                    <input class="form-check-input" type="radio" @change="change()" name="radioworkerJob" id="all_workerJob" v-model="workerJob" :value="''">
                    <label class="form-check-label" for="all_workerJob">{{ $t('all') }}</label>
                </div>
            </div>
            <template v-for="(value, index) in opt" :key="index" >
                <div class="col-lg-6">
                    <div class="form-check mb-2" >
                        <input class="form-check-input" type="radio" @change="change()" name="radioworkerJob" :id="'workerJob'+index" v-model="workerJob" :value="value.value">
                        <label class="form-check-label" :for="'workerJob'+index">{{ value.name }}</label>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import { storeS } from '@/store';

export default {
    props: ['worker'],
    data(){
        return {
            // workerJob: "",
            opt: [
                {
                    name: this.$t('managerCallCenter'),
                    value: "managercallcenter"
                },
                {
                    name: this.$t('SalesManager'),
                    value: "salesmanager"
                },
                {
                    name: this.$t('SupportManager'),
                    value: "supportmanager"
                },
                {
                    name: this.$t('Developer'),
                    value: "developer"
                },
                {
                    name: this.$t('CEO'),
                    value: "ceo"
                },
                {
                    name: this.$t('Tester'),
                    value: "tester"
                },
                {
                    name: this.$t('SMM'),
                    value: "smm"
                },
                {
                    name: this.$t('Marketer'),
                    value: "marketer"
                },
            ]
        }
    },
    created(){
        this.workerJob = this.worker
    },
    methods: {
        change(){
            this.$emit('change', 'workerJob', this.workerJob)
        },
    },
    computed: {
        // providers(){
        //     return storeS.providers
        // }
    }
}
</script>